import React from "react";
import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from "@headlessui/react";
import plus from "../../images/icons/plus.svg";
import minus from "../../images/icons/minus.svg";

interface AccordionItem {
  id: string;
  header: string;
  body: string;
}

interface AccordionProps {
  title: string;
  description: string;
  vector?: string;
  data: AccordionItem[];
}

const Accordion: React.FC<AccordionProps> = ({
  title,
  description,
  vector,
  data,
}) => {
  return (
    <div className="w-full">
      <div className="mx-auto max-w-7xl px-8 sm:px-10 lg:px-12 py-12">
        <div className="w-full">
          {/* <div className="flex items-center gap-8">
            <div className="w-1/3">
              <img
                src={vector}
                alt=""
                className="w-full h-full brightness-100 hover:brightness-105"
              />
            </div>
            <div className="w-2/3"> */}
          <h2 className="bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent text-3xl lg:text-4xl font-bold uppercase leading-10 lg:leading-[48.76px] drop-shadow-lightBlue">
            {title}
          </h2>
          <p className="text-justify text-dark/50 text-base lg:text-lg font-normal my-4 leading-6">
            {description}
          </p>
          {/* </div>
          </div> */}

          <dl className="space-y-2">
            {data.map((item, index) => (
              // use stable id if available, otherwise fall back to index
              <Disclosure as="div" key={item.id} className="pt-4">
                {({ open }) => (
                  <>
                    <dt>
                      <DisclosureButton className="w-full bg-gray flex items-center p-5 rounded-t-xl rounded-bl-xl drop-shadow-darkBlue">
                        <div className="w-5/6 text-dark text-sm lg:text-base text-left font-bold leading-5 uppercase">
                          {item.header}
                        </div>
                        <div className="w-1/6 flex justify-end items-center">
                          {open ? (
                            <img
                              className="w-4 lg:w-6 h-4 lg:h-6"
                              src={minus}
                              alt="minus-svg"
                            />
                          ) : (
                            <img
                              className="w-4 lg:w-6 h-4 lg:h-6"
                              src={plus}
                              alt="plus-svg"
                            />
                          )}
                        </div>
                      </DisclosureButton>
                    </dt>

                    <DisclosurePanel
                      as="dd"
                      className="bg-slate-100 p-5 rounded-bl-xl"
                    >
                      <div className="text-dark/75 text-sm lg:text-base font-normal leading-5 space-y-2">
                        {item.body?.split("\n").map((line, lineIndex) => {
                          const trimmed = line.trim();

                          const renderWithLink = (text: string) =>
                            text
                              .split("terms of service")
                              .map((part, partIndex, arr) => (
                                <React.Fragment key={partIndex}>
                                  {part}
                                  {partIndex < arr.length - 1 && (
                                    <a
                                      href="/terms"
                                      className="underline hover:no-underline text-primary"
                                    >
                                      terms of service
                                    </a>
                                  )}
                                </React.Fragment>
                              ));

                          // IMPORTANT: use a unique key for each returned element
                          const key = `${index}-${lineIndex}`;

                          if (trimmed.startsWith("#")) {
                            return (
                              <h3 key={key} className="font-semibold">
                                {renderWithLink(
                                  trimmed.replace("#", "").trim(),
                                )}
                              </h3>
                            );
                          } else if (trimmed.endsWith(",")) {
                            return (
                              <p key={key}>
                                - {renderWithLink(trimmed.slice(0, -1).trim())}
                              </p>
                            );
                          } else if (trimmed.endsWith(".pdf")) {
                            return (
                              <a
                                href={`/Trassir/${trimmed}`}
                                download={trimmed}
                              >
                                {trimmed}
                              </a>
                            );
                          } else {
                            return <p key={key}>{renderWithLink(trimmed)}</p>;
                          }
                        })}
                      </div>
                    </DisclosurePanel>
                  </>
                )}
              </Disclosure>
            ))}
          </dl>
        </div>
      </div>
    </div>
  );
};
export default Accordion;
